'use client'

import { ThemeContext } from '~react-widget-components/ThemeContext'

import { COLOR_CONTRAST } from '../App.types'
import { getColorContrast } from '../utils/get-color-contrast'

const TEXT_COLOR = {
  [COLOR_CONTRAST.LIGHT]: 'white',
  [COLOR_CONTRAST.DARK]: 'black',
}

const BLACK_COLOR_HEX = '#000000'

interface Props {
  children: React.ReactNode
  venuePrimaryColor?: string | null
  companyPrimaryColor?: string | null
  backgroundColor?: string | null
}

export function ThemeProvider({ children, venuePrimaryColor, companyPrimaryColor, backgroundColor }: Props) {
  const primaryColor = companyPrimaryColor || venuePrimaryColor || BLACK_COLOR_HEX

  const contrastToPrimary = primaryColor ? getColorContrast(primaryColor) : COLOR_CONTRAST.LIGHT
  const textColor = TEXT_COLOR[contrastToPrimary]

  const cssCustomProperties = {
    '--primary': primaryColor || 'hsl(var(--primary-400))',
    '--text': textColor,
    '--background': backgroundColor ?? 'hsl(var(--white))',
  } as React.CSSProperties

  return (
    <ThemeContext.Provider value={{ primaryColor }}>
      <div className="bg-(--background) text-text-primary" style={cssCustomProperties}>
        {children}
      </div>
    </ThemeContext.Provider>
  )
}
